/**
 * PageLoader - Loading fallback for React.lazy() code splitting
 *
 * Shows a centered loading spinner while lazy-loaded components are being fetched.
 * Used as the fallback prop in React.Suspense wrappers.
 */

import { Box, CircularProgress, Typography } from '@mui/material';

interface PageLoaderProps {
  message?: string;
}

export function PageLoader({ message = 'Loading...' }: PageLoaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}

export default PageLoader;
